import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=67751b1f&scoped=true&"
import script from "./ServicePage.vue?vue&type=script&lang=js&"
export * from "./ServicePage.vue?vue&type=script&lang=js&"
import style0 from "./ServicePage.vue?vue&type=style&index=0&id=67751b1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67751b1f",
  null
  
)

export default component.exports